import React, { ReactElement } from "react";
import Button from "../button";
import FilterTag from "./filter-tag";
import { FilterHeaderProps } from "./filter.types";

const FilterHeader = ({
  showFiltersText = "Show Filters",
  hideFiltersText = "Hide Filters",
  resultsCount,
  resultsCountSuffix = "Results",
  onToggleFiltersClick,
  appliedFilterTags,
  onRemoveFilterInternal,
  onClearAllFiltersInternal,
  renderAppliedFiltersHiddenText,
  filterExpanded,
  clearAllText = "Clear all",
}: FilterHeaderProps): ReactElement => {
  return (
    <div className="spark-filter__header">
      <div className="spark-filter__toggle-container spark-clearfix">
        <span className="spark-filter__result-label">
          {resultsCount ? `${resultsCount} ${resultsCountSuffix}` : ""}
        </span>
        <Button
          className="spark-filter__toggle-button"
          textOnly
          onClick={onToggleFiltersClick}
        >
          {filterExpanded ? hideFiltersText : showFiltersText}
        </Button>
      </div>

      <div className="spark-filter__tags-container">
        <div className="spark-filter__applied-filters-counter hide">
          {renderAppliedFiltersHiddenText ? (
            renderAppliedFiltersHiddenText(appliedFilterTags.length)
          ) : (
            <>
              <span>{appliedFilterTags.length}</span> Filters
            </>
          )}
        </div>
        {appliedFilterTags.map((appliedFilterInfo) => (
          <FilterTag
            {...appliedFilterInfo}
            key={`${appliedFilterInfo.name}_${appliedFilterInfo.value}`}
            onRemove={(e, name, value): void =>
              onRemoveFilterInternal(e, name, value)
            }
          />
        ))}
        {appliedFilterTags.length > 0 ? (
          <a
            tabIndex={0}
            className="spark-filter__clear-all spark-zeta"
            onClick={onClearAllFiltersInternal}
          >
            {clearAllText}
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default FilterHeader;
